<!--
 * @Descripttion: 
 * @FilePath: /mall-wap-vue/src/views/bannerlink/index.vue
 * @Author: 张兴业
 * @Date: 2021-01-11 09:35:58
 * @LastEditors: 张兴业
 * @LastEditTime: 2021-01-11 10:06:08
-->
<template>
  <div class="banner_link">
    <img :src="url" alt="" />
  </div>
</template>

<script>
export default {
  inject: ["$G"],
  data() {
    return {
      preLink: this.$G("https://assets.img.myazstore.com/bannerlink/")
    };
  },
  computed: {
    url() {
      const { imageName, imageType } = this.$route.query;
      return `${this.preLink}${imageName}${imageType}`;
    }
  }
};
</script>

<style lang="less" scoped>
.banner_link {
  img {
    width: 100%;
    display: block;
  }
}
</style>
